import script from "./TrainingView.vue?vue&type=script&lang=ts&setup=true"
export * from "./TrainingView.vue?vue&type=script&lang=ts&setup=true"

import "./TrainingView.vue?vue&type=style&index=0&id=b4f4b1ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4f4b1ee"]])

export default __exports__